export const FETCH_CUSTOMERS_INIT = 'CUSTOMERS::FETCH_CUSTOMERS_INIT';
export const FETCH_CUSTOMERS_SUCCESS = 'CUSTOMERS::FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_ERROR = 'CUSTOMERS::FETCH_CUSTOMERS_ERROR';
export const FETCH_COLLECTIONS_INIT = 'COLLECTIONS::FETCH_CUSTOMERS_INIT';
export const FETCH_COLLECTIONS_SUCCESS = 'COLLECTIONS::FETCH_CUSTOMERS_SUCCESS';
export const FETCH_COLLECTIONS_ERROR = 'COLLECTIONS::FETCH_CUSTOMERS_ERROR';
export const SET_STATE = 'CUSTOMERS::SET_STATE';
